import { sortingTable } from 'utils/_sort.js'

export default (
  selector
) => {

  sortingTable(selector, 'two')

}

